import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import {
  getPageDetailColumnList,
  getPageDetailTableViewList,
  getPageDetailsById,
} from "../../api/column";
import useErrorHandler from "../../hooks/useErrorHandler";
import { useSelector } from "react-redux";
import MultiSelectDropdown from "../../components/CustomizedDropdown";
import { getPageNameData, getSectionNameData } from "../../api/dynamic-view";

const useStyles = makeStyles(() => ({
  dialogRoot: {
    width: "600px", // Adjust the desired width here
    display: "flex",
    flexDirection: "column",
  },
}));
export default function AddPageDetailColumns({
  open,
  id,
  setOpen,
  loading,
  formData,
  setFormData,
  setCheckBlankLable,
  addUpdate,
  handleFormCreate,
}) {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ formData });

  const classes = useStyles();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const [columnsList, setColumnList] = useState([]);
  const [tableViewList, setTableViewList] = useState([]);
  const [tableName, setTableName] = useState("");
  const [pageName, setPageName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [pageNameListData, setPageNameDataList] = useState([]);
  const [sectionNameListData, setsectionNameDataList] = useState([]);
  useEffect(() => {
    setPageName(formData.pagename);
    setSectionName(formData.secname);
    setTableName(formData.viewname);
    // getPageColumnList();
  }, [open]);
  // async function getPageDetailById() {
  //   try {
  //     const { data } = await getPageDetailsById(user.token, id);
  //     console.log("data--", data.data[0]);
  //     const resultArray = convertStringToArray(data.data[0].colname);
  //     data.data[0].colname = resultArray;
  //     setFormData(data.data[0]);
  //   } catch (error) {
  //     console.log(error);
  //     //snackbar.showError("Error In Loading Data.");
  //     errorHandler(error);
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  // const handleSubmitdata = () => {
  //   const columnNamesString = columnNames.join(",");

  //   // Create the data object to be sent in the request body
  //   const data = {
  //     pageName,
  //     sectionName,
  //     tableName,
  //     columnNames: columnNamesString,
  //   };

  // async function getPageColumnList() {
  //   try {
  //     const { data } = await getPageDetailColumnList(user.token, {
  //       limit: 10,
  //       offset: 0,
  //       view_name: tableName,
  //     });

  //     setColumnList(data.data.ColumnsList);
  //   } catch (error) {
  //     console.log(error);
  //     //snackbar.showError("Error In Loading Data.");
  //     errorHandler(error);
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  async function getPageDetailsTableViewList() {
    try {
      const { data } = await getPageDetailTableViewList(user.token, {
        page_name: pageName,
        sec_name: sectionName,
      });
      setTableViewList(data.data.ViewList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  async function getPageNameList() {
    try {
      const { data } = await getPageNameData(user.token, {});
      setPageNameDataList(data.data.pageList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  async function getSectionNameList() {
    try {
      const { data } = await getSectionNameData(user.token, {
        page_name: pageName,
      });
      setsectionNameDataList(data.data.sectionList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  useEffect(() => {
    if (user.token) {
      getPageNameList();
      getSectionNameList();
      getPageDetailsTableViewList();
    }
    return;
  }, [pageName, sectionName]);
  useEffect(() => {
    if (user.token) {
      getPageDetailsTableViewList();
    }
    return;
    // getPageColumnList();
  }, [open]);

  const onValueChange = (option) => {
    setCheckBlankLable(option);
    const FillteredOptions = removeItemByColumnName(option, "id");
    const columnName = FillteredOptions.map((column) => ({
      column_name: column.column_name,
    }));
    const labelName = FillteredOptions.map((column) => ({
      label_name: column.label_name,
    }));

    setFormData({
      colname: convertToCSV(columnName),
      labelname: convertToCSVLabel(labelName),
    });
  };
  return (
    <Dialog
      classes={{ paper: classes.dialogRoot }}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle variant="h2">Add/Edit Page Detail</DialogTitle>
      <Box component="form">
        <DialogContent>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  fullWidth
                  error={Boolean(errors.pagename)}
                  required
                  shrink
                  disabled={addUpdate === "UPDATE" ? true : false}
                >
                  <InputLabel size="small" id="demo-simple-select-label-a">
                    Page Name
                  </InputLabel>
                  <Controller
                    defaultValue={formData.pagename}
                    render={(props) => (
                      <Select
                        size="small"
                        value={pageName}
                        onChange={(e) => {
                          setPageName(e.target.value);
                          props.onChange(e.target.value);
                        }}
                        label="Page Name"
                      >
                        {pageNameListData.map((item, i) => {
                          return (
                            <MenuItem value={item.pagename}>
                              {item.pagename}
                            </MenuItem>
                          );
                        })}
                        {/* <MenuItem value="users">users</MenuItem>
                        <MenuItem value="activity">activity</MenuItem> */}
                      </Select>
                    )}
                    name="pagename"
                    control={control}
                    rules={{
                      required: "Please select Page Name",
                    }}
                  />
                  <FormHelperText>{errors.pagename?.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl
                  fullWidth
                  error={Boolean(errors.secname)}
                  required
                  shrink
                  disabled={addUpdate === "UPDATE" ? true : false}
                >
                  <InputLabel size="small" id="demo-simple-select-label-a">
                    Section Name
                  </InputLabel>
                  <Controller
                    defaultValue={formData.secname}
                    render={(props) => (
                      <Select
                        size="small"
                        value={sectionName}
                        onChange={(e) => {
                          setSectionName(e.target.value);
                          props.onChange(e.target.value);
                        }}
                        label="Section Name"
                      >
                        {sectionNameListData.map((item, i) => {
                          return (
                            <MenuItem value={item.sec_name}>
                              {item.sec_name}
                            </MenuItem>
                          );
                        })}
                        {/* <MenuItem value="users">users</MenuItem>
                        <MenuItem value="activity">activity</MenuItem>
                        <MenuItem value="header">header</MenuItem> */}
                      </Select>
                    )}
                    name="secname"
                    control={control}
                    rules={{
                      required: "Please select Section Name",
                    }}
                  />
                  <FormHelperText>{errors.secname?.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl
                  fullWidth
                  error={Boolean(errors.viewname)}
                  required
                  shrink
                  disabled={addUpdate === "UPDATE" ? true : false}
                >
                  <InputLabel size="small" id="demo-simple-select-label-a">
                    Table Name
                  </InputLabel>
                  <Controller
                    defaultValue={
                      addUpdate === "UPDATE" ? formData.viewname : ""
                    }
                    render={(props) => (
                      <Select
                        size="small"
                        value={tableName}
                        onChange={(e) => {
                          setTableName(e.target.value);
                          props.onChange(e.target.value);
                        }}
                        label="Table Name"
                      >
                        {tableViewList.map((item, i) => {
                          return (
                            <MenuItem value={item.view_name}>
                              {item.view_name}
                            </MenuItem>
                          );
                        })}
                        {/* <MenuItem value="users">users</MenuItem>
                        <MenuItem value="activity">activity</MenuItem>
                        <MenuItem value="headers">headers</MenuItem> */}
                      </Select>
                    )}
                    name="viewname"
                    control={control}
                    rules={{
                      required: "Please select Table Name",
                    }}
                  />
                  <FormHelperText>{errors.viewname?.message}</FormHelperText>
                </FormControl>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <MultiSelectDropdown
                  prefilledValues={
                    addUpdate === "UPDATE" ? formData.colname : []
                  }
                  tableName={tableName}
                  onValueChange={onValueChange}
                ></MultiSelectDropdown> */}
              {/* <FormControl
                  fullWidth
                  error={Boolean(errors.colname)}
                  required
                  shrink
                >
                  <InputLabel size="small" id="demo-simple-select-label-a">
                    Column Name
                  </InputLabel>
                  <Controller
                    defaultValue={formData.colname}
                    render={(props) => (
                      <Select
                        size="small"
                        value={props.value}
                        onChange={props.onChange}
                        label="Column Name"
                        multiple
                      >
                        {columnsList.map((item, i) => {
                          return (
                            <MenuItem value={item.column_name}>
                              {item.column_name}
                            </MenuItem>
                          );
                        })}
                   
                      </Select>
                    )}
                    name="colname"
                    control={control}
                    rules={{
                      required: "Please select Column Name",
                    }}
                  />
                  <FormHelperText>{errors.colname?.message}</FormHelperText>
                </FormControl> */}
              {/* </Grid> */}
            </Grid>
            <Box display="flex" justifyContent="flex-end">
              <MultiSelectDropdown
                prefilledColumnValues={
                  addUpdate === "UPDATE" ? formData.colname : []
                }
                prefilledLabelValues={
                  addUpdate === "UPDATE" ? formData.labelname : []
                }
                tableName={tableName || formData.viewname}
                onValueChange={onValueChange}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className="erp-cancel-button"
            onClick={() => {
              setTableName("");
              setFormData({
                viewname: "",
                colname: [],
                pagename: "",
                secname: "",
              });
              setOpen(false);
            }}
          >
            Cancel
          </Button>
          {
            <Button
              disabled={loading && true}
              variant="contained"
              onClick={() => {
                handleSubmit(handleFormCreate)().then(() => {
                  // setTableName("");
                });
              }}
              // onClick={handleSubmit(handleFormCreate)}
              // onClick={() =>
              //   handleSubmit(
              //     handleFormCreate().then(() => {
              //       setTableName("");
              //     })
              //   )
              // }
            >
              Submit
            </Button>
          }
          {loading && (
            <Box sx={{ margin: 1 }}>
              <CircularProgress />
            </Box>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}

function convertStringToArray(str) {
  if (typeof str === "string") {
    return str.split(",");
  } else {
    return [];
  }
}
function convertToCSV(columnArray) {
  const columnNames = columnArray.map((obj) => obj.column_name);
  return columnNames.join(",");
}
function convertToCSVLabel(columnArray) {
  const labelNames = columnArray.map((obj) => obj.label_name);
  return labelNames.join(",");
}
function removeItemByColumnName(arr, columnNameToRemove) {
  return arr.filter((item) => item.column_name !== columnNameToRemove);
}
